import { useState } from 'react';

export default function Thanks2026lmsspghPage() {
  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #faf7ff 0%, #f3eeff 40%, #eef8f6 100%)' }}>

      {/* 星空背景 */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(50)].map((_, i) => {
          const sizes = [0.8, 1, 1.2, 1.5, 1.8, 2];
          const size = sizes[i % sizes.length];
          const lefts = [3,8,14,19,25,31,37,42,48,53,59,64,70,75,81,86,92,97,5,11,17,23,29,35,41,47,55,61,67,73,79,85,91,96,2,9,16,22,28,34,40,46,52,58,65,71,77,83,89,95];
          const tops = [5,12,18,24,30,36,42,48,54,60,66,72,78,84,90,7,13,19,25,31,37,43,49,55,61,67,73,79,85,91,3,10,16,22,28,34,40,46,52,58,64,70,76,82,88,94,8,15,21,27];
          const delays = [0,0.5,1,1.5,2,2.5,3,3.5,0.2,0.7,1.2,1.7,2.2,2.7,3.2,0.4,0.9,1.4,1.9,2.4,2.9,3.4,0.1,0.6,1.1,1.6,2.1,2.6,3.1,3.6,0.3,0.8,1.3,1.8,2.3,2.8,3.3,3.8,0.05,0.55,1.05,1.55,2.05,2.55,3.05,3.55,0.15,0.65,1.15,1.65];
          const durations = [2,2.5,3,3.5,4,2.2,2.7,3.2,3.7,2.4,2.9,3.4,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2,3.7,4.2,2.4,2.9,3.4,3.9,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2];
          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${lefts[i]}%`,
                top: `${tops[i]}%`,
                background: `rgba(160, 120, 220, 0.35)`,
                animation: `twinkle ${durations[i]}s ease-in-out infinite`,
                animationDelay: `${delays[i]}s`,
              }}
            />
          );
        })}
      </div>

      {/* 光のオーブ */}
      <div className="absolute top-20 left-1/4 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(160,120,240,0.1) 0%, transparent 70%)' }}></div>
      <div className="absolute bottom-40 right-1/4 w-80 h-80 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(60,180,160,0.08) 0%, transparent 70%)' }}></div>

      <div className="relative z-10 max-w-2xl mx-auto px-6 py-16">

        {/* ヘッダー */}
        <div className="text-center mb-10">
          <h1
            className="text-3xl md:text-4xl font-light mb-4"
            style={{ color: '#1a0533', fontFamily: "'Noto Serif JP', serif", lineHeight: 1.7, fontWeight: 700 }}
          >
            最後のお手続きへお進みください
          </h1>
          <p style={{ color: '#3b0764', fontSize: '15px', letterSpacing: '0.05em', fontWeight: 600, lineHeight: 1.8 }}>
            あなたの魂の旅が、今始まります。
          </p>
        </div>

        {/* 導入メッセージ */}
        <div
          className="rounded-2xl p-8 mb-6 text-center"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.3)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.1)',
          }}
        >
          <p style={{ color: '#1a0533', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4 }}>
            あなたは今、<br />
            古代レムリアの聖なる秘儀を受け取る準備が整いました。
          </p>
          <div style={{ width: '40px', height: '1px', background: 'linear-gradient(90deg, transparent, rgba(140,90,220,0.5), transparent)', margin: '20px auto' }}></div>
          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4 }}>
            これからあなたには<br />
            魂を目覚めさせる
          </p>
          <p style={{ color: '#4c1d95', fontSize: '18px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, marginTop: '12px' }}>
            特別な覚醒の儀式
          </p>
          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, marginTop: '12px' }}>
            が届けられます。
          </p>
        </div>

        {/* レムリアの儀式 */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.35)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.12)',
          }}
        >
          <div className="text-center mb-8">
            <p
              className="text-xs tracking-widest mb-4"
              style={{ color: '#5b21b6', letterSpacing: '0.3em', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 }}
            >
              ✦ LEMURIAN CEREMONY ✦
            </p>
            <h2
              className="text-xl md:text-2xl font-light mb-6"
              style={{ color: '#1a0533', fontFamily: "'Noto Serif JP', serif", lineHeight: 1.8, fontWeight: 700 }}
            >
              古代レムリアの聖なる秘儀
            </h2>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '24px' }}>
            古代レムリアでは<br />
            魂の覚醒を促すために
          </p>

          <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginBottom: '24px' }}>
            エネルギーのエレメントを使った儀式
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            が行われていました。
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            今回あなたには<br />
            そのエッセンスを受け取っていただきます。
          </p>

          {/* 3つの儀式 */}
          <div className="space-y-6 mb-8">
            <div className="text-center p-6 rounded-xl" style={{ background: 'rgba(255,100,100,0.08)', border: '1px solid rgba(255,100,100,0.2)' }}>
              <div className="text-3xl mb-2">🔥</div>
              <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '8px' }}>
                火の儀式
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2 }}>
                魂の情熱を目覚めさせる
              </p>
            </div>

            <div className="text-center p-6 rounded-xl" style={{ background: 'rgba(100,150,255,0.08)', border: '1px solid rgba(100,150,255,0.2)' }}>
              <div className="text-3xl mb-2">💧</div>
              <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '8px' }}>
                水の儀式
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2 }}>
                エネルギーと感情を浄化する
              </p>
            </div>

            <div className="text-center p-6 rounded-xl" style={{ background: 'rgba(150,200,255,0.08)', border: '1px solid rgba(150,200,255,0.2)' }}>
              <div className="text-3xl mb-2">🌬</div>
              <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '8px' }}>
                風の儀式
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2 }}>
                ハイヤーセルフと繋がる
              </p>
            </div>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center' }}>
            この3つの儀式を通して<br />
            あなたのエネルギーが整い
          </p>
          <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginTop: '12px' }}>
            本来の魂の力が目覚めていきます。
          </p>
        </div>

        {/* 8大特典について */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.35)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.12)',
          }}
        >
          <div className="text-center mb-6">
            <p
              className="text-xs tracking-widest mb-4"
              style={{ color: '#5b21b6', letterSpacing: '0.3em', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 }}
            >
              ✦ 8大特典について ✦
            </p>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '20px' }}>
            今回ご案内している
          </p>

          <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginBottom: '20px' }}>
            古代レムリアの聖なる秘儀<br />
            8大特典
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            はすべて
          </p>

          <p style={{ color: '#4c1d95', fontSize: '17px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            専用LINEから順番にお届けします。
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '24px' }}>
            LINEでは
          </p>

          <div className="space-y-3 mb-6">
            <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2, textAlign: 'center' }}>
              ・火・水・風の覚醒の儀式<br />
              ・エネルギーワーク<br />
              ・レムリアの叡智メッセージ<br />
              ・特別ワーク
            </p>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '12px' }}>
            など
          </p>

          <p style={{ color: '#4c1d95', fontSize: '16px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center' }}>
            魂の覚醒をサポートする特典
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginTop: '12px' }}>
            をお届けします。
          </p>
        </div>

        {/* 特典の受け取り方法 */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.35)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.12)',
          }}
        >
          <div className="text-center mb-6">
            <p
              className="text-xs tracking-widest mb-4"
              style={{ color: '#5b21b6', letterSpacing: '0.3em', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 }}
            >
              ✦ 特典の受け取り方法 ✦
            </p>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '24px' }}>
            8大特典は
          </p>

          <p style={{ color: '#4c1d95', fontSize: '17px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            LINE登録後に順番にお届けします。
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '24px' }}>
            またLINEでは
          </p>

          <div className="space-y-3 mb-6">
            <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2, textAlign: 'center' }}>
              ・儀式の解説<br />
              ・特別メッセージ<br />
              ・イベントの重要案内
            </p>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center' }}>
            もお届けします。
          </p>
        </div>

        {/* 3Days LIVE案内 */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.35)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.12)',
          }}
        >
          <div className="text-center mb-6">
            <p
              className="text-xs tracking-widest mb-4"
              style={{ color: '#5b21b6', letterSpacing: '0.3em', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 }}
            >
              ✦ NEXT CEREMONY ✦
            </p>
            <h2
              className="text-xl md:text-2xl font-light mb-4"
              style={{ color: '#1a0533', fontFamily: "'Noto Serif JP', serif", lineHeight: 1.8, fontWeight: 700 }}
            >
              そして、3日間の覚醒セレモニーへ
            </h2>
          </div>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '20px' }}>
            3つの儀式を受け取った後、
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            あなたをさらに深い覚醒へ導く
          </p>

          <p style={{ color: '#4c1d95', fontSize: '17px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            特別な3Days LIVE
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center', marginBottom: '32px' }}>
            をご用意しています。
          </p>

          <div className="text-center mb-6">
            <p
              className="text-xl md:text-2xl font-bold mb-2"
              style={{ color: '#4c1d95', fontFamily: "'Noto Serif JP', serif" }}
            >
              ハイヤーセルフ覚醒セレモニー<br />
              3Days LIVE
            </p>
            <div
              className="inline-block px-5 py-2 rounded-full text-sm mt-4"
              style={{
                background: 'rgba(140,90,220,0.15)',
                border: '1px solid rgba(140,90,220,0.5)',
                color: '#2d0a5e',
                letterSpacing: '0.08em',
                fontWeight: 700,
              }}
            >
              穴口恵子が直接導く<br />
              レムリア・アクティベーション
            </div>
          </div>

          <div className="space-y-4 mb-6">
            <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(140,90,220,0.08)', border: '1px solid rgba(140,90,220,0.2)' }}>
              <p style={{ color: '#4c1d95', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '4px' }}>
                DAY1
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600 }}>
                4月1日（水）21:00
              </p>
            </div>

            <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(140,90,220,0.08)', border: '1px solid rgba(140,90,220,0.2)' }}>
              <p style={{ color: '#4c1d95', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '4px' }}>
                DAY2
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600 }}>
                4月2日（木）21:00
              </p>
            </div>

            <div className="text-center p-4 rounded-xl" style={{ background: 'rgba(140,90,220,0.08)', border: '1px solid rgba(140,90,220,0.2)' }}>
              <p style={{ color: '#4c1d95', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 700, marginBottom: '4px' }}>
                DAY3
              </p>
              <p style={{ color: '#2d0a5e', fontSize: '14px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600 }}>
                4月3日（金）21:00
              </p>
            </div>
          </div>

          <p style={{ color: '#5b21b6', fontSize: '13px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, textAlign: 'center', marginBottom: '24px' }}>
            ※オンライン開催
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, textAlign: 'center' }}>
            参加方法は<br />
            LINEでご案内します。
          </p>
        </div>

        {/* LINE登録 */}
        <div
          className="rounded-2xl p-8 text-center"
          style={{
            background: 'rgba(255,255,255,0.95)',
            border: '1px solid rgba(140,90,220,0.35)',
            backdropFilter: 'blur(12px)',
            boxShadow: '0 4px 24px rgba(140,100,220,0.12)',
          }}
        >
          <p
            className="text-xs tracking-widest mb-6"
            style={{ color: '#5b21b6', letterSpacing: '0.3em', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 }}
          >
            ✦最後のお手続きはこちら ✦
          </p>

          <p style={{ color: '#2d0a5e', fontSize: '15px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2.4, marginBottom: '24px' }}>
            ▼こちらからLINEにご登録ください
          </p>

          <a
            href="#"
            className="inline-block px-10 py-4 rounded-full text-base font-bold transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{
              background: '#06C755',
              color: '#ffffff',
              boxShadow: '0 4px 16px rgba(6,199,85,0.3)',
              letterSpacing: '0.08em',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 24px rgba(6,199,85,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(6,199,85,0.3)';
            }}
          >
            LINE登録する
          </a>

          <p style={{ color: '#5b21b6', fontSize: '13px', fontFamily: "'Noto Serif JP', serif", fontWeight: 600, lineHeight: 2, marginTop: '24px' }}>
            ※LINE登録者のみ<br />
            儀式と8大特典を受け取ることができます
          </p>
        </div>

      </div>

      <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>
    </div>
  );
}